export enum ResetOptionType {
  SECURITY_QUESTION = 'security_question',
  VERIFICATION_CODE = 'verification_code',
  EMAIL = 'email'
}
